import { getCookie } from "./cookie";

/**
 * find a query param value
 * @param {String} key query param key
 * @param {String} location location url
 */
export function findURLParam(key, location) {
  let param,
    params_arr = [],
    queryString = (location.indexOf("?") !== -1) ? location.split("?")[1] : "";
  if (queryString !== "") {
    params_arr = queryString.split("&");
    for (var i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split("=")[0];
      if (param === key) {
        return params_arr[i].replace(`${key}=`, '');
      }
    }
  }
}

export const getAppendedSchemaName = () => {
  try {
    const urlParams = new URLSearchParams();
    const schemaNameFromCookie = getCookie("schema_name");
    urlParams.set('schema_name', schemaNameFromCookie);
    return '?' + urlParams.toString()
  } catch (e) {
    return ''
  }
}

// Convert `change or cancel your appointment. https://sandyspetdepot-etailplus.dev.etailpet.com/customers/booking/my-schedule/Thank you,Your team at Sandy's Pet Depot`
// to `change or cancel your appointment. https://sandyspetdepot-etailplus.dev.etailpet.com/customers/booking/my-schedule/ Thank you,Your team at Sandy's Pet Depot`
// Remove `/Thank` from URL
export function extractCorrectUrlFromString(str) {
  if (typeof str !== 'string') { return; }

  const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig;
  const urlArr = str.match(urlRegex)
  const url = urlArr?.[0]

  if (typeof url !== 'string') { return; }

  const stringWithoutThanks = url.replace('/Thank', '/');

  return stringWithoutThanks
}